import { FormAdapter, FormAlert, FormContainerOptions, FormControlProperties, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import { Resource } from '@reporting/rp-types/ext';
import { Module } from "@reporting/rp-types/accounting";
import rp from '@reporting/rp-app-host';

export class FileFormAdapter extends FormAdapter {

	private _file: Resource;

	public duplicate: boolean = false;

	constructor(readonly idProject: number, private idFile: number) { super() }

	async getFile() {
		if (this._file) return this._file;
		this._file = this.idFile ? await rp.ms('extensions').get<Resource>(`resources/${this.idFile}`) : {
			id_custom_page: this.idProject,
		};
		return this._file;
	}

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls(): Promise<FormControlProperties[]> {
		const file = await this.getFile();
		if (this.duplicate) {
			const parts = file.name.split('.');
			const ext = parts.length > 1 ? parts.pop() : '';
			file.name = `${parts.join('.')}_copy.${ext}`;
			this._file.id_custom_resource = this.idFile = this._file.idz = null;
		}
		const modules = (await rp.ms('accounting').get<Module[]>(`modules`))
			.filter(m => ['data', 'custom'].includes(m.type));

		let r = 0
		return [
			{row: r, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: r, col: 1, type: FormControlType.TextInput, key: 'name', value: file.name, required: true},
			{row: ++r, col: 0, type: FormControlType.Label, value: msg('Description'), for: 'description'},
			{row: r, col: 1, type: FormControlType.TextInput, key: 'description', value: file.description, required: false},
			{row: ++r, col: 0, type: FormControlType.Label, value: msg('Module')},
			{row: r, col: 1, type: FormControlType.List, key: 'module', value: file.module, content: {
				sourceData: modules.map(m => ({k: m.module, v: m.name, icon:{icon: 'cube', color: m.color}})), 
				options: {selectMode: 'single', autoClose: true}
			}}
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const fileValues = values.get(0);
		const file = await this.getFile();
		file.name = fileValues['name'] as string;
		file.module = fileValues['module'] as string;
		file.description = fileValues['description'] as string;
		await rp.ms('extensions').post<Resource>('resources', file);
		return true;
	}

}
